import React from "react";

const Button = ({ children, className, ...props }) => {
  return (
    <button
      className={`px-5 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg shadow-md transition transform hover:scale-105 ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
